import { combineReducers } from 'redux';
import { gisServices } from '@rsos/reduxDataStore';
import { psaps } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import { sinatra } from '@rsos/sinatra';
import mapLayerSettings from './MapLayerSettingsSlice';
import { appReducer } from './appSlice';
import { spatialLayers } from './spatialLayersSlice';

export const rootReducer = combineReducers({
  appDataSource: appReducer,
  sinatra,
  psaps,
  gisServices,
  spatialLayers,
  mapLayerSettings,
});

export type DatasourceManagementState = ReturnType<typeof rootReducer>;
